import React from "react";

export default function SQL_AND() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_AND</h1>
      <p>This is the SQL_AND component generated from the SQL JSON.</p>
    </div>
  );
}
